enum LandingViewName {
    JetBluePassenger = 'jetblue.passengers',
}

enum ViewName {
    TopNews = 'topnews',
    PagesView = 'pageview',
    TextView = 'textview',
    FTSArticles = 'ftsarticles',
    Bookmarks = 'bookmarks',
    Bookmark = 'bookmark',
    // PublicBookmarks:"publicbookmarks",
    ManageBookmarks = 'managebookmarks',
    EmailAlerts = 'emailalerts',
    Votes = 'votes',
    Home = 'home',
    Radio = 'radio',
    Monitors = 'monitors',
    Profile = 'profile',
    Similar = 'similar',
    EmptyView = 'emptyview',
    Categories = 'categories',
    External = 'external',
    Help = 'help',
    Opinion = 'opinion',
    OpinionsHub = 'opinionshub',
    OpinionsTrends = 'opinionstrend',
    Post = 'post',
    ReadingMap = 'readingmap',
    StoreHub = 'catalog',
    Error = 'error',
    Account = 'account',
    Purchase = 'purchaseview',
    Receipt = 'receipt',
    Article = 'article',
    Onboarding = 'onboarding',
    IssueDetails = 'issuedetails',
    LatestIssues = 'latestissues',
    Auth = 'auth',
    MyProfile = 'myprofile',
    Payment = 'payment',
    SiteMap = 'sitemap',
    DocumentView = 'documentview',
    GiftCard = 'giftcard',
    PromotionBilling = 'promotionbilling',
    Landing = 'landing',
    Publisher = 'publisher',
    // integrations
    MasterCard = 'mastercard',
    AmexSignUp = 'amexsignup ',
    GartnerConf = 'gartnerconf',
    BookDetails = 'bookdetails',
    AudiobookCatalog = 'audiobookcatalog',
    AudiobookFeatured = 'audiobookfeatured',
    AudiobookDetails = 'audiobookdetails',
    Wttc = 'wttc',
    FijiAir = 'fijiair',
    StarLux = 'starlux',
    Ethiopianair = 'ethiopianair',
    Tishman = 'tishman',
    Vna = 'vna',
    Mondia = 'mondia',
    Search = 'search',
    BookView = 'bookview',
    FindHotspot = 'findhotspot',
    Supplements = 'supplements',
    EmailVerified = 'emailverified',

    // games
    GameCategory = 'gamecategory',
    GameTitle = 'gametitle',
    GameDetails = 'gamedetails',
    GameDetailsLatest = 'gamedetailslatest',
    GameIssuePlayer = 'gameissueplayer',
    GameIssueNotAvailable = 'gameissuenotavailable',

    // Chat
    AskView = 'ask',
}

enum CatalogView {
    Catalog = 'catalog',
    Books = 'books',
    Newspapers = 'newspapers',
    Magazines = 'magazines',
    OnlineEditions = 'online-editions',
    PDFBooks = 'pdfbooks',
    Games = 'games',
}

export { CatalogView, LandingViewName, ViewName };
